export const FETCH_SERVICES_REQUEST = 'FETCH_SERVICES_REQUEST'
export const FETCH_SERVICES_FULFILLED = 'FETCH_SERVICES_FULFILLED'
export const FETCH_SERVICES_ERRED = 'FETCH_SERVICES_ERRED'
export const CREATE_SERVICE_REQUEST = 'CREATE_SERVICE_REQUEST'
export const CREATE_SERVICE_FULFILLED = 'CREATE_SERVICE_FULFILLED'
export const CREATE_SERVICE_ERRED = 'CREATE_SERVICE_ERRED'
export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST'
export const DELETE_SERVICE_FULFILLED = 'DELETE_SERVICE_FULFILLED'
export const DELETE_SERVICE_ERRED = 'DELETE_SERVICE_ERRED'
